/**
 * @Description 奥乐齐特有的竞争系数
 */

import { FC } from 'react';
import { Row, Col, Spin } from 'antd';
import { isNotEmpty } from '@lhb/func';
import cs from 'classnames';
import styles from './index.module.less';
import IconFont from '@/common/components/IconFont';


interface ALQSearchModuleProps {
  coefficientVal: any;
  handleALQView: () => void;
};
const ALQSearchModule: FC<ALQSearchModuleProps> = ({
  coefficientVal,
  handleALQView
}) => {

  return (
    <Spin spinning={coefficientVal?.isLoading}>
      <Row gutter={10} className='mt-10'>
        <Col span={coefficientVal?.hasLoadedData ? 12 : 10}>
          <div className={styles.valueItemCon}>
            <div>
              <div className={cs('fs-16 bold ff-number-bold',
                coefficientVal?.hasLoadedData ? '' : styles.mosaicCon)}>{
                  isNotEmpty(coefficientVal.standardCompetitionCoefficient) ? `${coefficientVal.standardCompetitionCoefficient}%` : '-'
                }</div>
              <div className='fs-12 c-666'>标准竞争系数</div>
            </div>
            <div className={styles.imgCon}>
              <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/youth/icon_coefficient_1@2x.png`} width='100%' height='100%' />
            </div>
          </div>
        </Col>
        <Col span={coefficientVal?.hasLoadedData ? 12 : 10}>
          <div className={cs(styles.valueItemCon, styles.other)}>
            <div>
              <div className={cs('fs-16 bold ff-number-bold',
                coefficientVal?.hasLoadedData ? '' : styles.mosaicCon)}>{
                  isNotEmpty(coefficientVal.secondaryCompetitionCoefficient) ? `${coefficientVal.secondaryCompetitionCoefficient}%` : '-'
                }</div>
              <div className='fs-12 c-666'>次级竞争系数</div>
            </div>
            <div className={styles.imgCon}>
              <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/youth/icon_coefficient_2@2x.png`} width='100%' height='100%' />
            </div>
          </div>
        </Col>
        {
          !coefficientVal?.hasLoadedData ? <Col
            span={4}
            onClick={() => {
              handleALQView && handleALQView();
            }}>
            <div className={styles.viewBtn}>
              <IconFont iconHref='iconic_dateboard1' className='fs-14'/>
              <div className='fs-12 c-006 pl-2'>立即查看</div>
            </div>
          </Col> : <></>
        }
      </Row>
    </Spin>
  );
};

export default ALQSearchModule;
